module.exports = __webpack_public_path__ + "img/1547905122.e2664ae5.jpg";